import routerOptions0 from "/app/dev/node_modules/nuxt/dist/pages/runtime/router.options";
import routerOptions1 from "/app/dev/app/router.options.ts";
const configRouterOptions = {
  strict: true,
  hashMode: false,
  scrollBehaviorType: "auto"
}
export default {
...configRouterOptions,
...routerOptions0,
...routerOptions1,
}